export const getCorrectText = (value: number, options: { [key: number]: string }): string => {
	if (value > 100) {
		value %= 100;
	}

	if (value > 10 && value < 20) {
		return options['567890'];
	}

	const lastNumber = value % 10;

	switch (lastNumber) {
		case 1:
			return options['1'];
		case 2:
		case 3:
		case 4:
			return options['234'];
		default:
			return options['567890'];
	}
};

export const getCategoriesNumberText = (value: number): string => {
	const options = {
		1: 'услуга',
		234: 'услуги',
		567890: 'услуг',
	};

	return getCorrectText(value, options);
};

export const getAdditionalText = (value: number): string => {
	const options = {
		1: 'Найдена',
		234: 'Найдено',
		567890: 'Найдено',
	};

	return getCorrectText(value, options);
};

export const getDeadlineText = (value: number, isNominative = false): string => {
	const options = {
		1: 'дня',
		234: 'дней',
		567890: 'дней',
	};

	const nominativeOptions = {
		1: 'день',
		234: 'дня',
		567890: 'дней',
	};

	return getCorrectText(value, isNominative ? nominativeOptions : options);
};

export const getRatingText = (value: number): string => {
	const options = {
		1: 'отзыв',
		234: 'отзыва',
		567890: 'отзывов',
	};

	return getCorrectText(value, options);
};
